

export function getSalesSummaryReportHeader() {
  return [
    {
      title: 'Size',
      dataIndex: 'prod_size',
      key: 'prod_size',
      sorter: (a, b) => a?.prod_size?.localeCompare(b?.prod_size),
      fixed: 'left',
    },
    {
      title: 'Total Kilos Sold',
      dataIndex: 'total_sold',
      key: 'total_sold',
      sorter: (a, b) => a.total_sold - b.total_sold,
    },

    {
      title: 'Total Tanks Sold',
      dataIndex: 'total_tank',
      key: 'total_tank',
    },
    {
      title: 'Total Amount in Peso',
      dataIndex: 'total_amount',
      key: 'total_amount',
      sorter: (a, b) => a.total_amount - b.total_amount,
      render: (total_amount) => `₱ ${Number(total_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
    },
 
 
  ];
}

